<template>
  <div v-if="session && session.testmode" class="fixed top-0 left-0 overflow-hidden w-[100px] h-[100px] text-right z-[999999]"><span
      class="text-sm font-bold text-white uppercase text-center leading-tight -rotate-45 w-[140px] block bg-markencode-blue shadow-md absolute top-[29px] -left-[31px]">TEST</span>
  </div>
</template>

<script>
export default {
  props: {
    session: {
      type: Object,
      required: false,
    },
  },
};
</script>
